import { render, staticRenderFns } from "./SwishCredentials.vue?vue&type=template&id=4bdc576c&scoped=true"
import script from "./SwishCredentials.vue?vue&type=script&lang=js"
export * from "./SwishCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc576c",
  null
  
)

export default component.exports